export default "__VITE_ASSET__82d0b389__"